export const getMissingValuesBetweenArrays = ({
  currentArray = [],
  targetArray = [],
}) => {
  return targetArray.filter((item) => !currentArray.includes(item));
};

/** TikTok scope IDs can exceed Number.MAX_SAFE_INTEGER; compare as strings. */
export const integrationScopeKey = (scopeId) => {
  if (scopeId == null || scopeId === "") return "";
  return typeof scopeId === "string" ? scopeId : String(scopeId);
};

export const getMissingIntegrationScopes = ({
  currentArray = [],
  targetArray = [],
}) => {
  const currentKeys = new Set(
    (currentArray || []).map(integrationScopeKey).filter(Boolean)
  );
  return targetArray.filter(
    (target) => !currentKeys.has(integrationScopeKey(target))
  );
};

export const getDuplicateItemsArray = (array = []) => {
  if (!Array.isArray(array)) return [];
  const countMap = {};
  const duplicates = [];

  // Contamos las ocurrencias de cada elemento
  array.forEach((item) => {
    countMap[item] = (countMap[item] || 0) + 1;
  });

  // Filtramos los duplicados (elementos con más de una ocurrencia)
  for (const [key, count] of Object.entries(countMap)) {
    if (count > 1) {
      duplicates.push(key);
    }
  }

  return duplicates;
};

export const getArrayIntersection = (array1 = [], array2 = []) => {
  return array1.filter((item) => array2.includes(item));
};

export const getArrayEmptyValues = (array) => {
  return array.filter((item) => item === "");
};
